import { TOKEN_REFRESH_THRESHOLD_MS } from "@/constants/auth-session.constants";
import { IDecodedToken } from "@/interfaces/auth.interfaces";

// Margem de segurança para diferenças de relógio entre cliente e servidor.
export const CLOCK_SKEW_MS = 30 * 1000;

export const isTokenExpired = (decodedToken: IDecodedToken): boolean => {
  return Date.now() > decodedToken.exp * 1000 - CLOCK_SKEW_MS;
};

export const isTokenNearExpiry = (decodedToken: IDecodedToken): boolean => {
  const expiration = decodedToken.exp * 1000;
  return expiration - Date.now() <= TOKEN_REFRESH_THRESHOLD_MS;
};
